import { Howl } from 'howler';

WL.registerComponent('synced-shot', {
}, {
    init: function() {
        this.posX = 0;
        this.posY = 0;
        this.posZ = 0;
        this.shotSound = new Howl({
            "src": [
                "sfx/laser.mp3",
        ]});

    },
    playSpatialShot: function(pos){
      if(this.posX == pos.x && this.posY == pos.y && this.posZ == pos.z) {
        return;
      }
      this.posX = pos.x;
      this.posY = pos.y;
      this.posZ = pos.z;
      const currentId = this.shotSound.play();
      this.shotSound.pos(this.posX, this.posY, this.posZ, currentId);
    },
});
